import { AccordionTrigger } from "@radix-ui/react-accordion";
import { RhIcon } from "@rhythm-ui/react";
import React from "react";

const JobAnalyticsSkeleton = () => {
  return (
    <div className="animate-pulse space-y-6">
      <div className="grid grid-cols-4 gap-4">
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="space-y-3 rounded bg-blue-50 p-4">
            <div className="h-4 w-24 rounded" />
            <div className="h-6 w-16 rounded" />
          </div>
        ))}
      </div>

      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="space-y-4 rounded bg-slate-100 p-5">
          <div className="h-5 w-48 rounded" />

          <div className="h-[260px] w-full rounded" />
        </div>
      ))}
    </div>
  );
};

export default JobAnalyticsSkeleton;

export const AccordionHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <AccordionTrigger className="group flex w-full items-center justify-between rounded px-4 py-3 text-left font-medium hover:bg-slate-50">
    <span>{children}</span>

    <RhIcon
      icon="tabler:chevron-down"
      className="h-4 w-4 transition-transform duration-200 group-data-[state=open]:rotate-180"
    />
  </AccordionTrigger>
);
